(function(){
  var hero = document.querySelector('.snt .hero');
  if (!hero) return;
  var media = hero.querySelector('.hprod');
  var bar = document.querySelector('.snt .mcta');
  var root = document.documentElement;
  var mq = window.matchMedia('(max-width:760px)');

  function sizeHero(){
    if (!media) return;
    root.style.removeProperty('--sn-hero-h');
    if (!mq.matches) return;
    var top = media.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
    var h = Math.max(500, Math.min(window.innerHeight - top - 30, 820));
    root.style.setProperty('--sn-hero-h', Math.round(h) + 'px');
  }

  var ticking = false;
  function update(){
    ticking = false;
    if (!bar) return;
    if (!mq.matches) { bar.classList.remove('snhid'); return; }
    var r = hero.getBoundingClientRect();
    var vh = window.innerHeight || 0;
    var visible = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
    var ratio = visible / Math.max(1, Math.min(r.height, vh));
    bar.classList.toggle('snhid', ratio > 0.42);
  }
  function onScroll(){ if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  sizeHero();
  update();
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', function(){ sizeHero(); onScroll(); });
  window.addEventListener('orientationchange', function(){ setTimeout(function(){ sizeHero(); onScroll(); }, 250); });
})();

(function(){
  var main = document.getElementById('snMain');
  if (!main) return;
  var slides = main.querySelectorAll('.sn-gslide');
  if (!slides.length) return;

  function heightFor(i){
    var s = slides[i] || slides[0];
    if (!s) return 0;
    var im = s.querySelector('img');
    var h = im ? im.getBoundingClientRect().height : 0;
    if (!h) h = s.getBoundingClientRect().height;
    if (!h && im && im.naturalWidth) h = im.clientWidth * im.naturalHeight / im.naturalWidth;
    return Math.round(h);
  }
  function current(){ return Math.max(0, Math.min(slides.length - 1, Math.round(main.scrollLeft / Math.max(1, main.clientWidth)))); }
  function apply(){
    var h = heightFor(current());
    if (h > 0) main.style.setProperty('--sn-gh', h + 'px');
  }

  var pending = null;
  function onScroll(){ if (pending) return; pending = setTimeout(function(){ pending = null; apply(); }, 40); }

  slides.forEach(function(s){
    var im = s.querySelector('img');
    if (im && !(im.complete && im.naturalWidth)) im.addEventListener('load', apply);
  });
  main.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
  window.addEventListener('load', apply);
  apply();
})();
